import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, unref as _unref, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

import { computed } from "vue";
import { useI18n } from "vue-i18n";
import { useRoute } from "vue-router";
import { DesktopPanelTheme, MobilePanelTheme } from ".";
import store from "@/store";

import { config } from "@/common/settings/config";


export default /*@__PURE__*/_defineComponent({
  __name: 'panel',
  setup(__props) {

const { t } = useI18n();
const route = useRoute();

const accountId = computed(() => route.params.id as string);

const menuList = computed(() =>
  config.menu.full.map((item) => ({
    ...item,
    label: t(item.label),
  }))
);

return (_ctx: any,_cache: any) => {
  return (!_ctx.$store.getters.mobile)
    ? (_openBlock(), _createBlock(_unref(DesktopPanelTheme), {
        key: 0,
        "menu-list": menuList.value
      }, {
        main: _withCtx(() => [
          _renderSlot(_ctx.$slots, "default")
        ]),
        _: 3
      }, 8, ["menu-list"]))
    : (_openBlock(), _createBlock(_unref(MobilePanelTheme), {
        key: 1,
        "menu-list": menuList.value,
        "account-id": accountId.value
      }, {
        main: _withCtx(() => [
          _renderSlot(_ctx.$slots, "default")
        ]),
        _: 3
      }, 8, ["menu-list", "account-id"]))
}
}

})